/* eslint-disable @typescript-eslint/no-empty-interface */
import * as React from "react";
import { useState, useRef, useEffect, useContext } from "react";

import { connect } from "react-redux";
import { Button } from "reactstrap";
import { Table } from "reactstrap";
import {
  Field,
  reduxForm,
  getFormValues,
  InjectedFormProps,
  getFormNames,
} from "redux-form";
import "./ownershipQuestions.scss";
import deleteIcon from "../../../../../Images/delete.svg";
import IndividualIcon from "../../../../../images/individual-user.svg";
import businessIcon from "../../../../../images//business-and-trades.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";

import { AxiosError, AxiosResponse } from "axios";
import { cloneDeep, initial } from "lodash";
import { Input } from "reactstrap";
import { OwnershipInformationdata, State } from "./OwnershipInformationdata";
import { BankUserContext } from "../../../../../bankUserContext";
import { catchError } from "../../../../../utils/Utils";
import Service from "../../../../../services";
import { useParams } from "react-router-dom";
import YesOrNo from "../../../../../commonfields/YesorNoSelect";




interface OwnershipQuestionnarieFormProps {
  OwnershipInformationdata: OwnershipInformationdata | null;
  getAllOwnershipContacts: any;
  getIndividuals: any;
  entityType: any;
  clientId: string;
  getStockSymbol: any;
}
const OwnershipQuestionnarieForm: React.FunctionComponent<
  // eslint-disable-next-line @typescript-eslint/ban-types
  OwnershipQuestionnarieFormProps &
  InjectedFormProps<any, OwnershipQuestionnarieFormProps>
> = (props: any) => {
  const [individualContacts, setIndividualContacts] = useState<any>([]);
  const [addedRows, setAddedRows] = useState<any>([]);
  const bankUserContext = React.useContext(BankUserContext);
  const [newRowValues, setNewRowValues] = useState<any>({ type: { value: 'Individuals' } });
  const [loader, setLoader] = useState<boolean>(false);
  const [businessOwners, setBusinessOwners] = useState<any>({});
  const [stockSymbol, setStockSymbol] = useState<any>({});
  const service = new Service();
  const [targetTop, setTargetTop] = useState("0");
  const [states, setStates] = useState<State[]>([]);
  const { clientProductId } = useParams();
  const context = useContext(BankUserContext);
  const typeValues = [
    // { value: "", label: "Select", disabled: true },
    {
      value: "Business",
      label: (
        <div className="option-box">
          <div className="icon">
            <img src={businessIcon} alt="businessIcon" />
          </div>
          <div className="text">Business</div>
        </div>
      ),
    },
    {
      value: "Individuals",
      label: (
        <div className="option-box">
          <div className="icon">
            <img src={IndividualIcon} alt="IndividualIcon" />
          </div>
          <div className="text">Individual</div>
        </div>
      ),
    },
  ];

  const yesNoValues = [
    { value: "true", text: "Yes" },
    { value: "false", text: "No" },
  ];
  const yesorNo = [
    { value: "selectd", text: "N/A" },
    { value: "Yes", text: "Yes" },
    { value: "No", text: "No" },
    // { value: "N/A", text: "N/A"  }
  ];

  const [newRow, setNewRow] = useState(false);

  const isEntityType = (type: string) => {
    return props.entityType?.text === type;
  }

  const resetNewRowValues = () => {
    if (isEntityType("Sole Proprietorship")) {
      const temp = cloneDeep(newRowValues);
      temp.ownership = 100;
      temp.type = { value: 'Individuals' };
      setNewRowValues(temp);
    }
  }
  const getStates = () => {
    const payload = {

      "screen": "Ownership module",

      "sections": "getStatesFilter",

      "isJsonReturnObject": true,

      "orgId": context.bankuserDetails?.organization.orgId


    }
    service.getStatesData(payload)
      .then(resp => setStates(resp.data))
      .catch((error: AxiosError) => {
        setStates([]);
        catchError(error, true);
      });
  }

  const getChildren = (
    _owners: any,
    type: string,
    owners: Array<OwnershipInformationdata>
  ) => {
    const temp: any = {};
    const _businessOwners = _owners[type].owners.filter(
      (o: any) => o.type === "Business"
    );
    _businessOwners.forEach((bO: any) => {
      temp[bO.ownerId] = {};
      temp[bO.ownerId].owners = owners.filter(
        (o) => o.parentOwnerId === bO.ownerId
      );
      temp[bO.ownerId]["answer"] =
        temp[bO.ownerId]["owners"][0]?.publicTradedCompany;
      temp[bO.ownerId].children = getChildren(temp, bO.ownerId, owners);
    });
    return temp;
  };

  const groupByOwners = (owners: Array<OwnershipInformationdata>) => {
    owners = owners || [];
    const bOwners: any = {
      parent: {
        owners: [],
      },
    };
    bOwners.parent.owners = owners.filter((o: any) => !o.parentOwnerId);
    bOwners.parent.answer = bOwners.parent.owners[0]?.publicTradedCompany + "";
    bOwners.parent.children = getChildren(bOwners, "parent", owners);

    setBusinessOwners(bOwners);
  };

  const getAllOwnershipContacts = () => {

    service
      .getAllContacts(clientProductId)
      .then((response: AxiosResponse<OwnershipInformationdata[]>) => {
        const owners = response.data || [];
        setIndividualContacts(owners);
        groupByOwners(owners);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  const saveStackSymbol = (data: any) => {
    setLoader(true);

    delete data.parentOwnerId;
    if (stockSymbol) {
      data.stockSymbolId = stockSymbol.stockSymbolId;
    }
    data.publicTradedCompany = data.publicTradedCompany + "";
    data.duplicateIndividuals = data.duplicateIndividuals || "";
    let payload = cloneDeep(data);
    if (payload.publicTradedCompany == 'false') {
      payload = {
        publicTradedCompany: payload.publicTradedCompany,
        stockSymbolId: payload.stockSymbolId
      };
    }
    service.postSaveStockSymbol(payload).then((response: any) => {
      setLoader(false);
      getAllOwnershipContacts();
      props.getAllOwnershipContacts();
      props.getIndividuals();
      props.getStockSymbol();
      if (response.status === 200) {
        console.log("res", response);
      }
    });
  };

  const saveRow = (row: any, mode: string) => {
    setLoader(true);
    if (row.stockSymbol && !row.ownerId) {
      saveStackSymbol(row);
    } else if (mode === "add" || mode === "update") {
      service
        .postOwnerInformation(row)
        .then((response: any) => {
          setLoader(false);
          setNewRow(false);
          setNewRowValues({});
          props?.reset("OwnershipQuestionnarieForm");
          if (response.status === 200) {
            console.log("res", response);

            if (row.parentOwnerId) {
              const temp = cloneDeep(individualContacts);
              const owner = temp.find((c: any) => c.ownerId === row.parentOwnerId) || {};
              owner.newRow = false;
              setIndividualContacts(temp);
            }

            else {
              setStockSymbol({ ...stockSymbol, newRow: false });
            }
            getAllOwnershipContacts();
            props.getAllOwnershipContacts();
            props.getIndividuals();
            props.getStockSymbol();
          }
        })

        .catch((er: any) => {
          if (er.response.data.code === 400) {
            console.log("res", er);
            toast.error(
              <>
                <div className="fileErrorMessage">
                  {er.response.data.errorMessage}
                </div>
              </>
            );
          } else {
            catchError(er, true);
          }
          setLoader(false);
        });
    }
  };

  const getTotal = (id: any, ownerId: any = null) => {
    let total = 0;
    individualContacts
      .filter((o: any) => {
        if (ownerId && ownerId === o.ownerId) {
          return false;
        }
        if (id === "parent" && !o.parentOwnerId) {
          return true;
        }
        if (id !== "parent" && id === o.parentOwnerId) {
          return true;
        }

        return false;
      })
      .map((o: any) => {
        total += +o.ownership;
      });

    return total;
  };
  const getOwner = (id: string) => {
    return individualContacts.find((c: any) => c.ownerId === id) || {};
  };
  const changeField = (
    f: string,
    v: any,
    parentId: string,
    ownerId: string | null
  ) => {
    let isYesClicked = "false";
    if (f == "stockSymbol") {
      isYesClicked = "true";
    }
    const row = (ownerId && getOwner(ownerId)) || {};
    console.log("row", row);
    if (f === "ownership" && v > 100) {
      return;
    }
    if (f === "ownership") {
      if (getTotal(parentId, ownerId) + v > 100) {
        return false;
      }

    }
    if ((row && ownerId) || f == "stockSymbol") {
      row[f] = v;

      row.publicTradedCompany = isYesClicked;
      if (f !== 'stockSymbol') {
        row.ownerId = ownerId;
        row.type = row?.type?.value ?? row?.type;
      }

      if (row.parentOwnerId === "parent") {
        row.parentOwnerId = null;
      }
      saveRow(row, "update");
    } else {
      const _newRowValues = cloneDeep(newRowValues);
      _newRowValues[f] = v;

      if (((_newRowValues?.type?.value === 'Business' && _newRowValues["firstname"])
        ||
        (_newRowValues?.type?.value === 'Individuals' && _newRowValues["firstname"] && _newRowValues["lastname"]))
        && _newRowValues["address1"] && _newRowValues["city"]
        && _newRowValues["state"] && _newRowValues["zipcode"] && _newRowValues["ownership"]
        && ((parentId === "parent" && _newRowValues?.type?.value === 'Individuals'
          && _newRowValues["corporateOfficer"] && _newRowValues["authSigner"])
          || parentId !== "parent" || _newRowValues?.type?.value === 'Business')) {
        let p = {
          ...newRowValues,
          [f]: v,
          parentOwnerId: parentId === "parent" ? null : parentId,
        };
        if (f === "stockSymbol") {
          // p.type = 'Personal';
          const owner = (ownerId && getOwner(ownerId)) || {};
          p = { ...p, ...owner, publicTradedCompany: "true" };
        }
        p = { ...p, type: p?.type?.value ?? p?.type };

        saveRow(p, "add");

      } else {
        setNewRowValues(_newRowValues);
      }
    }
  };

  const formElement: any = useRef();


  const changeStockSymbol = (e: any, id: string) => {
    e.preventDefault();

    //setNewRow(true);
    if (id === "parent") {
      setStockSymbol({ ...stockSymbol, stockSymbol: e.target?.value });
    } else {
      const temp = cloneDeep(individualContacts);
      const owner = temp.find((c: any) => c.ownerId === id) || {};
      owner.stockSymbol = e.target?.value;
      setIndividualContacts(temp);
    }
  };

  const changeSelectedIndex = (id: string, value: any) => {
    if (id === "parent") {
      const temp = cloneDeep(stockSymbol);
      temp.selectedIndex = value;
      setStockSymbol(temp);
    } else {
      const temp = cloneDeep(individualContacts);
      const owner = temp.find((c: any) => c.ownerId === id) || {};
      owner.selectedIndex = value;
      setIndividualContacts(temp);
    }
  };

  const removeRowData = (id: string) => {
    setLoader(true);
    if (
      ((id !== "parent" &&
        (Number(getOwner(id)?.selectedIndex + "") >= 0
          ? getOwner(id)?.selectedIndex
          : -1)) ||
        (id === "parent" &&
          (Number(stockSymbol?.selectedIndex + "") >= 0
            ? stockSymbol?.selectedIndex
            : -1))) >= 0
    ) {
      const owners = individualContacts.filter((o: any) => {
        if (id !== "parent") {
          return o.parentOwnerId == id;
        } else {
          return !o.parentOwnerId;
        }
      });
      const pO = id !== "parent" ? getOwner(id) : stockSymbol;
      const selectedOwnerId = owners[pO.selectedIndex]?.ownerId;
      selectedOwnerId &&
        service
          .deleteContact(selectedOwnerId, props.clientProductsId)
          .then((response: any) => {
            setLoader(false);

            if (response.status === 200) {
              toast.success(
                <>
                  <div className="fileErrorMessage">contact Deleted</div>
                </>
              );
              getAllOwnershipContacts();
              setNewRowValues({});

              props?.reset("OwnershipQuestionnarieForm");
              changeSelectedIndex(id, -1);
            }
          })

          .catch((error: any) => catchError(error, true));
    }
  };

  const getStockSymbol = () => {
    setLoader(true);
    service
      .getStockSymbol(clientProductId)
      .then((response: any) => {
        setLoader(false);
        setStockSymbol(response?.data || {});
      })

      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  useEffect(() => {
    getAllOwnershipContacts();
    getStockSymbol();
    getStates();
  }, []);

  useEffect(() => {
    if (isEntityType("Sole Proprietorship")) {
      resetNewRowValues();

    }

  }, [props.entityType]);


  // const ismangeingMemberHeading =() => {
  //   if(isEntityType('Corporation')){
  //     return "Corporate Officer"
  //   }
  //   if(isEntityType('Limited Liability Company')){
  //     return "Managing Member"
  //   }
  //   if(isEntityType('Partnership')){
  //     return "Managing Partner"
  //   }
  //   if(isEntityType('Sole Proprietorship')){
  //     return "Corporate Officer"
  //   }
  // }

  const displayRemove = (id: any) => {
    if (id === "parent") {
      const temp = cloneDeep(stockSymbol);
      temp.hasRemoveRow = true;
      setStockSymbol(temp);
    } else {
      const temp = cloneDeep(individualContacts);
      const owner = temp.find((c: any) => c.ownerId === id) || {};
      owner.hasRemoveRow = true;
      setIndividualContacts(temp);
    }
  };

  const hideRemove = (id: any) => {
    if (id === "parent") {
      const temp = cloneDeep(stockSymbol);
      temp.hasRemoveRow = false;
      temp.selectedIndex = -1;
      setStockSymbol(temp);
    } else {
      const temp = cloneDeep(individualContacts);
      const owner = temp.find((c: any) => c.ownerId === id) || {};
      owner.hasRemoveRow = true;
      owner.selectedIndex = -1;
      setIndividualContacts(temp);
    }
  };

  const onDelete = (e: Event, index: number, id: any, ownerId: any) => {
    if (id === "parent") {
      const temp = cloneDeep(stockSymbol);
      temp.selectedIndex = index;
      temp.selectedOwnerId = ownerId;
      setStockSymbol(temp);
      setTargetTop((index + 1) * 36.6 + "px");
    } else {
      const temp = cloneDeep(individualContacts);
      const owner = temp.find((c: any) => c.ownerId === id) || {};
      owner.selectedIndex = index;
      owner.selectedOwnerId = ownerId;
      setIndividualContacts(cloneDeep(temp));
      setTargetTop((index + 1) * 36.6 + "px");
    }
  };
  const deleteOwnersData = (id: any = null) => {
    const _owners = individualContacts.filter((owner: any) => owner.parentOwnerId === id)
    _owners.length && service.deleteAllOwners(id, props.clientProductsId).then((response: any) => {
      getAllOwnershipContacts();
      props.getAllOwnershipContacts();
      props.getIndividuals();
    });
  };

  const onAnswer = (answer: boolean, id: string) => {
    if (id !== "parent") {
      const temp = cloneDeep(individualContacts);
      const _owner = temp.find((c: any) => c.ownerId === id) || {};
      _owner.publicTradedCompany = answer;
      //temp[id]["answer"] = answer;
      console.log("temp", temp);
      saveRow(_owner, "update"); //to do save publicTradedCompany for yes no

      setIndividualContacts(temp);
    } else {
      const temp = cloneDeep(stockSymbol);
      temp.publicTradedCompany = answer;
      if ((answer + '') == 'false') {
        temp.stockSymbol = '';
      }
      setStockSymbol(temp);
      saveStackSymbol(temp);
    }
    if (answer + "" == "true") {
      deleteOwnersData(id === "parent" ? null : id);
    }

  };

  const ismangeingMemberHeading = () => {
    if (isEntityType('C-Corp') || isEntityType('Sole Proprietorship') || isEntityType('Other') || isEntityType('Corporation')) {
      return "Corporate Officer"
    }
    if (isEntityType('Limited Liability Company') || isEntityType('LLC')) {
      return "Managing Member"
    }
    if (isEntityType('Partnership')) {
      return "Managing Partner"
    }
    return "Corporate Officer"
  }

  const getName = (row: any, type: string) => {
    if (type === "name") {
      return [
        row.prefix,
        row.firstname,
        row.middlename,
        row.lastname,
        row.suffix,

      ]
        .filter((v) => v)
        .join(" ");
    }
    if (type === "address") {
      return [row.address1, row.address2, row.city, row.state, row.zipcode]
        .filter((v) => v)
        .join(" ");
    }
  };




  const renderQuestion = (id: string, _parent?: any) => {
    const _owner = getOwner(id);
    const owners =
      id === "parent"
        ? businessOwners[id]?.owners || []
        : _parent[id].owners || [];
    const fName = [
      _owner.firstname || "",
      _owner.middlename || "",
      _owner.lastname || "",
      _owner.prefix || "",
      _owner.suffix || "",
    ]
      .filter((v) => v)
      .join(" ");
    const question =
      id === "parent"
        ? "Is the applying company a publicly traded company?"
        : `Is ${fName} company a publicly traded company?`;
    return (
      <>
        {!(isEntityType("Sole Proprietorship")) ? <div>
          <div>
            <Field
              component={YesOrNo}
              disabled={true}
              name={"question_" + id}
              label={question}
              helpText={question}
              isRequired="true"
              defaultValue={
                id !== "parent"
                  ? getOwner(id)?.publicTradedCompany
                  : stockSymbol?.publicTradedCompany
              }
              options={yesNoValues}
              onChange={(a: any) => onAnswer(a, id)}

            />
          </div>
        </div> : ''}
        {(id !== "parent" && getOwner(id)?.publicTradedCompany == "true") ||
          (id == "parent" && stockSymbol.publicTradedCompany == "true") && !(isEntityType("Sole Proprietorship")) ? (
          <div className="stocksymbol">
            <span className="stocktext">
              Please provide the company stock symbol:
            </span>
            <Input
              type={"text"}
              autoComplete="off"
              disabled
              className="stockSymbolTextbox"
              value={
                id === "parent"
                  ? stockSymbol?.stockSymbol
                  : getOwner(id)?.stockSymbol
              }
              onChange={(e: any) => changeStockSymbol(e, id)}
              onBlur={(e: any) =>
                e.target.value && changeField("stockSymbol", e.target.value, id, _owner?.ownerId)
              }

            />
          </div>
        ) : (id !== "parent" && getOwner(id)?.publicTradedCompany == "false") ||
          (id == "parent" && stockSymbol.publicTradedCompany == "false") ||
          (isEntityType("Sole Proprietorship")) ? (
          <div className="formcontrol ownershipTableContainer">
            <Table className="ownershipTable">
              <thead>
                <tr className="headers">
                  <th>Type</th>
                  <th colSpan={2}>Full Name</th>
                  <th>% Ownership</th>
                  <th colSpan={2}>Home Address</th>
                  {id === "parent" ? (
                    <>
                      <th>{ismangeingMemberHeading()}</th>
                      <th>Authorized Signers</th>
                    </>
                  ) : (
                    ""
                  )}
                </tr>
              </thead>
              <tbody>
                {owners.map((row: any, index: number, { fields }: any) => (
                  <tr
                    key={index}

                  >
                    <td
                      width="50px"

                    >
                      {!(isEntityType("Sole Proprietorship")) && row.type === "Business" ? (
                        <img src={businessIcon} alt="businessIcon" />
                      ) : (
                        <img src={IndividualIcon} alt="IndividualIcon" />
                      )}
                    </td>
                    <td
                      colSpan={2}

                    >

                      {
                        getName(row, "name")
                      }
                    </td>
                    <td
                      width="65px"

                    >
                      {
                        row.ownership
                      }
                    </td>

                    <td
                      colSpan={2}

                    >
                      {
                        getName(row, "address")
                      }
                    </td>
                    {id === "parent" ? (
                      <>
                        <td
                          width="70px"

                        >

                          {
                            row.corporateOfficer
                          }
                        </td>
                        <td
                          width="70px"

                        >

                          {
                            row.authSigner
                          }
                        </td>
                      </>
                    ) : (
                      ""
                    )}

                  </tr>
                ))}


              </tbody>
              <tfoot>
                <tr className="footers">
                  {getTotal(id) === 100 ? (
                    <th colSpan={3} className="equalto">
                      Ownership must equal 100%
                    </th>
                  ) : (
                    <th colSpan={3} className="mustequal">
                      Ownership must equal 100%
                    </th>
                  )}

                  <th colSpan={5} className="percentage">
                    Total:&nbsp;
                    {getTotal(id) === 100 ? (
                      <span className="equalto">{getTotal(id)}%</span>
                    ) : (
                      <span className="mustequal">{getTotal(id)}%</span>
                    )}
                    {getTotal(id) === 100 ? (
                      <span className="equalto">/100%</span>
                    ) : (
                      <span>/100%</span>
                    )}
                  </th>



                </tr>
              </tfoot>
            </Table>


          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  const renderBusinessQuestions = (_businessOwners: any) => {
    return Object.keys(_businessOwners.children).map((bo) => (
      <div key={bo} className="business_owners">
        {renderQuestion(bo, _businessOwners.children)}
        {renderBusinessQuestions(_businessOwners?.children[bo])}

      </div>
    ));
  };

  return (
    <>
      <form className="ownership" ref={formElement}>
        {renderQuestion("parent")}
        {businessOwners?.parent?.children
          ? renderBusinessQuestions(businessOwners.parent)
          : ""}

      </form>
    </>
  );
};

const mapStateToProps = (
  state: Record<string, unknown>,
  props: OwnershipQuestionnarieFormProps
) => {
  return {
    initialValues: {
      firstname: props.OwnershipInformationdata?.firstname,
      prefix: props.OwnershipInformationdata?.prefix,
      suffix: props.OwnershipInformationdata?.suffix,
      middlename: props.OwnershipInformationdata?.middlename,
      lastname: props.OwnershipInformationdata?.lastname,
      state: props.OwnershipInformationdata?.state,
      city: props.OwnershipInformationdata?.city,
      street: props.OwnershipInformationdata?.street,
      authSigner: props.OwnershipInformationdata?.authSigner,
      corporateOfficer: props.OwnershipInformationdata?.corporateOfficer,
      type: props.OwnershipInformationdata?.type,
      ownership: props.OwnershipInformationdata?.ownership,
      address1: props.OwnershipInformationdata?.address1,
      address2: props.OwnershipInformationdata?.address2,
      unit: props.OwnershipInformationdata?.unit,
      createdBy: props.OwnershipInformationdata?.createdBy,
      createdDate: props.OwnershipInformationdata?.createdDate,
      ownerId: props.OwnershipInformationdata?.ownerId,
      parentOwnerId: props.OwnershipInformationdata?.parentOwnerId,
      publicTradedCompany: props.OwnershipInformationdata?.publicTradedCompany,
      stockSymbol: props.OwnershipInformationdata?.stockSymbol,
      updatedBy: props.OwnershipInformationdata?.updatedBy,
      updatedDate: props.OwnershipInformationdata?.updatedDate,
      zipcode: props.OwnershipInformationdata?.zipcode,
    },
    formValues: getFormValues("OwnershipQuestionnarieForm")(state),
  };
};

export default connect((state: any) => {
  return {
    formValues: getFormValues("OwnershipQuestionnarieForm")(state),
  };
})(
  // eslint-disable-next-line @typescript-eslint/ban-types
  reduxForm<{}, OwnershipQuestionnarieFormProps>({
    form: "OwnershipQuestionnarieForm",
    //validate,
  })(OwnershipQuestionnarieForm)
);


